// moment
import moment from "moment";
// utils
import { inputMask } from "../../../../utils/helpers/masks/masks";

// Formatadores de exibição do relatório de Vendas Consolidadas (tabela e XLSX).

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

// aplica uma máscara de inputMask e devolve o resultado como string
function applyMask(mask, value) {
  let masked = value;
  inputMask({ mask, value, setMaskedValue: (v) => (masked = v) });
  return masked;
}

// normaliza para string sem espaços nas pontas; vazio/nulo vira ""
function toText(value) {
  if (value === null || value === undefined) return "";
  return String(value).trim();
}

// "1600.00" -> "R$ 1.600,00"; valor vazio ou não numérico vira ""
export function formatAmount(value) {
  const text = toText(value);
  if (text === "") return "";
  const number = Number(text);
  if (Number.isNaN(number)) return "";
  // o Intl usa espaço não separável depois do "R$"; troca por espaço comum
  return currencyFormatter.format(number).replace(/ /g, " ");
}

// só os dígitos do CPF/CNPJ (para copiar sem pontuação); vazio vira ""
export function documentDigits(value) {
  return toText(value).replace(/\D/g, "");
}

// CPF (11 dígitos) ou CNPJ (14 dígitos) quando vêm só dígitos; demais ficam como vieram
export function formatDocument(value) {
  const text = toText(value);
  if (!/^\d+$/.test(text)) return text;
  if (text.length === 11) return applyMask("cpf", text);
  if (text.length === 14) return applyMask("cnpj", text);
  return text;
}

// link do WhatsApp (https://wa.me/55DDDNUMERO); número brasileiro sem DDI recebe o 55.
// Sem dígitos suficientes para um telefone, volta "" (sem link).
export function whatsappLink(value) {
  const digits = toText(value).replace(/\D/g, "");
  if (digits.length === 10 || digits.length === 11) return `https://wa.me/55${digits}`;
  if (digits.startsWith("55") && (digits.length === 12 || digits.length === 13))
    return `https://wa.me/${digits}`;
  return "";
}

// link de e-mail (mailto:); sem valor, volta ""
export function mailtoLink(value) {
  const text = toText(value);
  return text ? `mailto:${text}` : "";
}

// data e hora curtas no fuso do navegador ("30/08/26 09:15"); sem valor, ""
// as datas da API vêm como instante absoluto (ISO com Z), então o moment já exibe em SP
export function formatDateTime(value) {
  return value ? moment(value).format("DD/MM/YY HH:mm") : "";
}

// celular (11 dígitos) ou fixo (10 dígitos) quando vêm só dígitos; demais ficam como vieram
export function formatMobile(value) {
  const text = toText(value);
  if (!/^\d+$/.test(text)) return text;
  if (text.length === 11) return applyMask("cellphone", text);
  if (text.length === 10) return applyMask("phone", text);
  return text;
}
